import React, {useEffect} from "react";
import './index.css'
import {useSelector} from "react-redux";
import StyleHelper from "../../helpers/styleHelper";
import {useTranslation} from "react-i18next";
import associateServices from "../../services";
import {toast} from "react-toastify";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import StringHelper from "../../helpers/string-helper";
import SidebarLanguage from "../../components/sidebar/language";
import {useLocation} from "react-router-dom";

const Page403 = () => {
    const {configuration} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()

    const location = useLocation()

    useEffect(() => {
        StyleHelper.setThemeButtons(configuration)
    }, [configuration])

    const setThemeByConf = (data) => {
        let themeValue = localStorage?.getItem('theme')
        if (!data?.has_themes) {
            themeValue = data?.theme
        } else {
            if (!['light', 'dark'].includes(themeValue))
                themeValue = data?.theme
        }

        // getCssFiles(themeValue)
        StyleHelper.setThemeButtons(data);

        store.dispatch(GLOBAL_ACTIONS.setThemeAction(themeValue))
        document.documentElement.setAttribute('data-bs-theme', themeValue);


    }

    useEffect(() => {


        associateServices.getConfiguration({})
            .then(res => {

                if (res?.status !== 200) {

                    // TODO SHOW ERROR PAGE !
                } else {

                    if (res?.data?.data?.languages?.length <= 0) {
                        return toast.error('No language content found !')
                    }


                    store.dispatch(GLOBAL_ACTIONS.setConfigurationAction(res?.data?.data || {}))


                    const pathSegments = location.pathname.split('/');
                    const urlLanguage = pathSegments[1] || 'en' // Assuming the language is the first segment

                    if (res?.data?.data?.languages?.find(oo => urlLanguage === oo.key)) {
                        // If the URL language is supported, change the language in i18next
                        store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(urlLanguage))
                    } else {
                        store.dispatch(GLOBAL_ACTIONS.setActiveLanguage('en'))
                    }


                    localStorage.setItem('w_id', res?.data?.data?.w_id)
                    localStorage.setItem('w-secret', res?.data?.data?.secret)
                    localStorage.setItem('base:color', res?.data?.data?.color)

                    // setFavicon(res?.data?.data?.favicon)
                    document.documentElement.style.setProperty('--tf-active', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-skeleton', StringHelper.hexToRgba(res?.data?.data?.bg_light, .4));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.2));
                    document.documentElement.style.setProperty('--tf-border', StringHelper.hexToRgba(res?.data?.data?.color, .05));
                    document.documentElement.style.setProperty('--tf-borderhover', StringHelper.hexToRgba(res?.data?.data?.color, .2));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.08));
                    document.documentElement.style.setProperty('--tf-border-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.4));
                    document.documentElement.style.setProperty('--tf-btncolor', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-before-color', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .8)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .1)} 100%)`);
                    // linear-gradient(to right, #093028 0%, #237A57 51%, #093028 100%);
                    document.documentElement.style.setProperty('--tf-cool-button', `linear-gradient(to right, ${StringHelper.adjustBrightness(res?.data?.data?.color, -80)} 0%,${StringHelper.adjustBrightness(res?.data?.data?.color, -20)} 51%, ${StringHelper.adjustBrightness(res?.data?.data?.color, 10)} 100%)`);
                    document.documentElement.style.setProperty('--tf-logo', `url(${res?.data?.data?.logo_white})`);
                    document.documentElement.style.setProperty('--tf-logo2', `url(${res?.data?.data?.logo_dark})`);
                    document.documentElement.style.setProperty('--tf-bg', `${res?.data?.data?.bg_light}`);
                    document.documentElement.style.setProperty('--tf-bg2', `${res?.data?.data?.bg2_light}`);
                    document.documentElement.style.setProperty('--mini-logo', `url(${res?.data?.data?.mini_logo})`);
                    document.documentElement.style.setProperty('--tf-btn', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.05)} 100%)`);
                    document.documentElement.style.setProperty('--tf-btn2', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.02)} 100%)`);
                    document.documentElement.style.setProperty('--tf-vip', `linear-gradient(90deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .02)}  0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .04)}  33%, ${StringHelper.hexToRgba(res?.data?.data?.color, .06)}  66%, ${StringHelper.hexToRgba(res?.data?.data?.color, .08)}  100%)`);


                    setThemeByConf(res?.data?.data)

                    // setTimeout(() => setLoadingConf(res?.status !== 200), 500)
                }

            })
    }, [])

    return (
        <div className={`page-error`}>
            <div className="containerme">
                <div className="error-title">
                    <strong>{t('restricted-region.title')}</strong>
                    <span>{t('restricted-region.description')}</span>
                </div>
                <p>
                    {t('restricted-region.sub1')}
                    <br/>
                    {t('restricted-region.sub2')}
                </p>
                <div className="error-content">
                    <div className="error-code">
                        <h1 className={`number`}>
                            403
                        </h1>
                        <h1 className={`gradient`}>
                            403
                        </h1>
                    </div>

                    <img src={configuration?.forbidden_image} alt=""/>


                </div>
                <SidebarLanguage/>

                {/*<FormButton*/}
                {/*    label={t('sidebar.homepage')}*/}
                {/*    loading={false}*/}
                {/*    disabled={false}*/}
                {/*    onClick={null}*/}
                {/*/>*/}
            </div>
        </div>

    );
}

export default Page403
